module.exports = __webpack_public_path__ + "img/cardinal_vlvj2s.04cbbf49.svg";